export default "__VITE_ASSET__f56a7e41__"